module.exports = __webpack_public_path__ + "static/media/LinkedIn_IMG.b2355478.png";